import { animate, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'hour4u-admin-video-agent-alerts',
  templateUrl: './video-agent-alerts.component.html',
  styleUrls: ['./video-agent-alerts.component.scss'],
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(-10px)' }),
        animate('300ms ease-in', style({ opacity: 1, transform: 'translateY(0)' }))
      ])
    ])
  ]
})
export class VideoAgentAlertsComponent implements OnInit {

  @Input() detectionResults: any; // Receive detection results
  @Output() backToMain = new EventEmitter<void>(); // ✅ Emit event to parent


  alertsList: any[] = []; // Store multiple alerts over time


  ngOnInit() {

  }

  ngOnChanges() {
    if (!this.detectionResults) return;

    // Loop through the detection results
    Object.keys(this.detectionResults).forEach(keyword => {
      if (this.detectionResults[keyword]) { // If detected (true)
        // Push a new alert with a timestamp
        this.alertsList.unshift({
          keyword,
          timestamp: new Date().toLocaleString() // Store detection time
        });
      }
    });
  }

  // Assign different alert types
  getAlertClass(keyword: string): string {
    const lowerKeyword = keyword.toLowerCase();
    if (lowerKeyword.includes("phone") || lowerKeyword.includes("mobile")) {
      return "alert-card critical";
    } else if (lowerKeyword.includes("ceiling") || lowerKeyword.includes("test")) {
      return "alert-card warning";
    } else {
      return "alert-card success";
    }
  }

  // Define alert messages
  getAlertMessage(keyword: string): string {
    const messages: { [key: string]: string } = {
      "Phone": "Mobile phone detected in the scene.",
      "mobile": "Potential detection of mobile phone. Requires manual check.",
      "Human": "A human has been detected.",
      "bottle": "A bottle is present in the scene.",
      "ceiling": "Ceiling detected in the scene.",
      "TV": "A TV screen is visible.",
      "test": "Potential success detection."
    };

    return messages[keyword] || "Unknown alert detected.";
  }
  goBack() {
    this.backToMain.emit(); // Notify parent to set isConnected = false
  }

}
